module.exports = __webpack_public_path__ + "static/media/loading.08e3f609.svg";